import React from "react";
import { Dropdown } from "primereact/dropdown";
import useFormError from "../../hooks/useFormError";
import "primeflex/primeflex.css";
import '../css/Form.css'

const ProDropDown = ({ id, value, onChange, options, optionLabel, placeholder, disabled = false,
                       optionTemplate, valueTemplate, style = {}, headerText, formik = {}, error, required, filter=false, filterBy = "", showOptional = true }) => {   

    const getFormErrorMessage = useFormError(formik);
    const placeholderText = required ? <label htmlFor="dropdown">{placeholder}</label> 
                                      : <label htmlFor="inputtext" >{placeholder}
                                            <span style={{fontSize:11}}> {showOptional ? ' (optional)' : ''}</span>
                                        </label>

  return (
    <div>
      <div className="p-field p-col-12 p-md-12">
      {
        headerText && 
        <div className="p-d-flex p-jc-start">
        <h6 className="form-header">{headerText}</h6>
      </div>
      }
      <span className="p-float-label">
        <Dropdown style={{ ...style }}
          id={id}
          value={value}
          onChange={onChange}
          options={options}
          optionLabel={optionLabel}
          itemTemplate={optionTemplate}
          valueTemplate={valueTemplate}
          filter = {filter}
          filterBy = {filterBy}
          disabled = {disabled}
        />       
        {placeholderText}
      </span>     
    </div>
    <div>
      {error && getFormErrorMessage && getFormErrorMessage(error)}
      </div>
    </div>
  )
}

export default ProDropDown;